module.exports = __webpack_public_path__ + "img/2019.7f5ee7b8.jpg";